// components/SubMenu.tsx

import React, { useCallback, useState } from 'react';
import {
  Box,
  Drawer,
  IconButton,
  List,
  ListItem,
  ListItemButton,
  ListItemText,
  Toolbar,
  Link as MuiLink,
} from '@mui/material';
import MenuIcon from '@mui/icons-material/Menu';
import LogoutIcon from '@mui/icons-material/Logout';

import { useSubscription } from 'AppRoutes/context/SubscriptionContext';
import { useNavigate } from 'react-router-dom';
import { useAuth } from 'services/auth/authContext';
import { auth } from 'services/firebase/client';
import { getStoreNavPath, scrollToGrowlersCatalog } from 'utils/growlersFlow';
import { styles } from './styles';

const SubMenu = () => {
  const [drawerOpen, setDrawerOpen] = useState(false);
  const { loading } = useSubscription();
  const { currentUser } = useAuth();
  const navigate = useNavigate();
  const storeNavPath = getStoreNavPath();

  const isLoggedIn = Boolean(
    !loading && currentUser && !currentUser.isAnonymous,
  );

  const toggleDrawer = (open: boolean) => () => {
    setDrawerOpen(open);
  };

  const handleNavigate = useCallback(
    (path: string) => {
      navigate(path);
      setDrawerOpen(false);
    },
    [navigate],
  );

  const handleStoreClick = useCallback(
    (event: React.MouseEvent) => {
      if (!storeNavPath.includes('#')) {
        return;
      }
      if (window.location.pathname !== '/growlers') {
        return;
      }
      event.preventDefault();
      scrollToGrowlersCatalog();
    },
    [storeNavPath],
  );

  const handleLogout = useCallback(async () => {
    try {
      await auth.signOut();
      localStorage.clear();
    } catch (error) {
      console.error('Erro ao fazer logout:', error);
    }
    handleNavigate('/login');
  }, [handleNavigate]);

  return (
    <Box sx={{ ...styles.root, display: { xs: 'none', sm: 'block' } }}>
      <Toolbar sx={styles.toolbar}>
        <Box sx={styles.linksBox}>
          {isLoggedIn && (
            <IconButton
              edge="start"
              color="inherit"
              aria-label="menu"
              onClick={toggleDrawer(true)}
              sx={styles.menuButton}
            >
              <MenuIcon />
            </IconButton>
          )}

          <MuiLink href="/" sx={styles.link}>
            Assinatura de Cervejas
          </MuiLink>
          <MuiLink
            href={storeNavPath}
            onClick={handleStoreClick}
            sx={styles.link}
          >
            Loja
          </MuiLink>
          <MuiLink href="/cervejas-anteriores" sx={styles.link}>
            Cervejas anteriores
          </MuiLink>
          <MuiLink href="/envelhecidas" sx={styles.link}>
            Envelhecidas
          </MuiLink>
          <MuiLink href="/quem-somos" sx={styles.link}>
            Quem somos
          </MuiLink>
        </Box>
      </Toolbar>

      <Drawer anchor="left" open={drawerOpen} onClose={toggleDrawer(false)}>
        <Box sx={styles.drawer} role="presentation">
          <List>
            <ListItem disablePadding>
              <ListItemButton onClick={() => handleNavigate('/my-account')}>
                <ListItemText primary="Minha Conta" />
              </ListItemButton>
            </ListItem>
            <ListItem disablePadding>
              <ListItemButton onClick={() => handleNavigate('/mysubscription')}>
                <ListItemText primary="Minhas Assinaturas" />
              </ListItemButton>
            </ListItem>
            <ListItem disablePadding>
              <ListItemButton onClick={() => handleNavigate('/addresses')}>
                <ListItemText primary="Meus endereços" />
              </ListItemButton>
            </ListItem>
            <ListItem disablePadding>
              <ListItemButton onClick={() => handleNavigate('/orders')}>
                <ListItemText primary="Meus Pedidos" />
              </ListItemButton>
            </ListItem>
            <ListItem disablePadding>
              <ListItemButton onClick={() => handleNavigate('/support')}>
                <ListItemText primary="Suporte" />
              </ListItemButton>
            </ListItem>
            <ListItem disablePadding>
              <ListItemButton onClick={handleLogout}>
                <LogoutIcon sx={{ mr: 1 }} />
                <ListItemText primary="Sair" />
              </ListItemButton>
            </ListItem>
          </List>
        </Box>
      </Drawer>
    </Box>
  );
};

export default SubMenu;
